export const ManagerStyle = {
  noBorder: {
    border: "none",
    padding: "4px 12px",
    fontSize: "13px",
  },
  wrapper: {
    mb: "4px",
    marginX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "10px",
    maxHeight: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableCell: {
    color: "#637381",
    border: "none",
    background: "#f4f6f8",
    textAlign: "center",
    fontWeight: "700",
    fontSize: "12px",
    padding: "4px 8px",
    height: "30px",
  },
  tableHead: { borderRadius: "14px" },
  tableRow: { background: "#F4F6F8", height: "30px" },
};

